import { LinkLikeButtonV2 } from './link-like-button-v2';

export default LinkLikeButtonV2;
